export default __webpack_public_path__ + "static/media/cheese_quesidilla.cc59e856.jpg";